/**
 * Checks the video component to see if there is any audio tied to it and returns true/false
 * @param {object} video the entire video component
 * @returns {Boolean} a boolean
 */
export const hasAudio = video => {
  if (!video) return false;

  return (
    video.mozHasAudio ||
    !!video.webkitAudioDecodedByteCount ||
    (!!video.audioTracks && !!video.audioTracks.length)
  );
};
